import {axiosInstance} from './axios';

export async function loginApi(data) {
  try {
    return await axiosInstance.post("/api/v1/login/admin",data)
  }catch (e) {
    console.log('err')
    return null;
  }
}
